module.exports = __webpack_public_path__ + "img/cloud-icon.3974a235.svg";